// The worked W&B sheet's stylesheet: A4 portrait on paper, in paper colours
// whatever the app's theme. Like the pilot log it is mounted beside the app in
// .wb-print (hidden on screen, the only thing printed); on screen the same
// sheet is previewed inside the page.
export const WORKED_SHEET_CSS = `
@page { size: A4 portrait; margin: 12mm }
.wb-print { display: none }
@media print {
  body > *:not(.wb-print) { display: none !important }
  .wb-print { display: block }
  html, body { margin: 0 !important; padding: 0 !important; background: #fff !important }
  .wb-print .wb-sheet { width: auto !important; border: 0 !important; padding: 0 !important }
}
.wb-sheet {
  --ink: #14181d; --muted: #5a626c; --hair: #c5cad1; --head: #e8ebef; --key: #fff6bf;
  --ok: #17692f; --ok-bg: #eaf6ec; --bad: #b3261e; --bad-bg: #fbeceb;
  width: 794px; max-width: 100%; box-sizing: border-box; padding: 24px 28px; background: #fff; color: var(--ink);
  font: 12px/1.4 system-ui, -apple-system, 'Segoe UI', sans-serif;
  -webkit-print-color-adjust: exact; print-color-adjust: exact;
}
.wb-sheet * { box-sizing: border-box }
.wb-sheet .mono, .wb-sheet .num { font-family: ui-monospace, 'SF Mono', Menlo, Consolas, monospace; font-variant-numeric: tabular-nums }
.wb-sheet .num { text-align: right; white-space: nowrap }
.wb-sheet h1 { margin: 0; font-size: 20px }
.wb-sheet h2 { margin: 14px 0 4px; font-size: 12px; letter-spacing: .06em; text-transform: uppercase; break-after: avoid }
.wb-sheet h2 .step { display: inline-block; min-width: 18px; margin-right: 6px; padding: 0 4px; background: var(--ink); color: #fff; text-align: center; border-radius: 9px }
.wb-sheet .hd { display: flex; justify-content: space-between; align-items: baseline; border-bottom: 2px solid var(--ink); padding-bottom: 6px }
.wb-sheet .meta { display: flex; flex-wrap: wrap; gap: 2px 18px; margin-top: 6px; color: var(--muted) }
.wb-sheet .meta b { color: var(--ink) }
.wb-sheet table { width: 100%; border-collapse: collapse; break-inside: avoid }
.wb-sheet th, .wb-sheet td { border: 1px solid var(--hair); padding: 3px 6px; text-align: left; font-weight: 400 }
.wb-sheet th { background: var(--head); border-color: var(--ink); font-size: 11px; font-weight: 600 }
.wb-sheet th.num { text-align: right }
.wb-sheet tr.total td { font-weight: 700; background: var(--key) }
.wb-sheet table.factors td { font-size: 11px }
.wb-sheet .how { color: var(--muted); margin: 0 0 4px }
.wb-sheet .formula { margin: 6px 0 0; padding: 4px 8px; border: 1px solid var(--ink); background: var(--key) }
.wb-sheet .verdict { margin-top: 6px; padding: 4px 8px; font-weight: 700; border: 1.5px solid var(--ok); background: var(--ok-bg); color: var(--ok) }
.wb-sheet .verdict.bad { border-color: var(--bad); background: var(--bad-bg); color: var(--bad) }
.wb-sheet td.ok { color: var(--ok); font-weight: 700 }
.wb-sheet td.bad { color: var(--bad); font-weight: 700 }
.wb-sheet .chartbox { break-inside: avoid; max-width: 440px }
.wb-sheet .legend { display: flex; gap: 14px; font-size: 11px }
.wb-sheet .legend i { display: inline-block; width: 9px; height: 9px; margin-right: 4px; transform: rotate(45deg) }
.wb-sheet .chart { width: 100%; height: auto; display: block }
.wb-sheet .chart text { font: 8px system-ui, sans-serif; fill: #5a626c }
.wb-sheet .sign { display: flex; gap: 24px; margin-top: 18px; break-inside: avoid }
.wb-sheet .sign div { flex: 1; border-top: 1px solid var(--ink); padding-top: 2px; color: var(--muted); font-size: 11px }
.wb-sheet .note { margin-top: 10px; color: var(--muted); font-size: 10.5px }
`
